module.exports = __webpack_public_path__ + "static/media/live.643a166a.png";